import { transformLabels } from 'src/apps/mfa/helpers/QueryHelpers';
import { IMfaSessionDetails } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';

import { MfaSessionDetailsQuery } from '../MfaSessionDetails.generated';

export const transformMfaSessionDetailsResults = (
	rawResults: MfaSessionDetailsQuery
): IMfaSessionDetails | null => {
	const sessionData = rawResults.mfa_session_runs?.filter(returnNonNull)?.[0];

	if (!sessionData) {
		return null;
	}

	const allLabels = transformLabels(
		sessionData.custom_fields,
		sessionData.app,
		sessionData.app_version
	);

	return {
		sessionId: sessionData.run_id,
		sessionName: sessionData.session_name,
		runTime: sessionData.run_time,
		lastModified: sessionData.run_updated_at,
		owner: sessionData.user_name,
		labels: allLabels.length > 0 ? allLabels : undefined
	};
};
